import { YouTubeIcon } from './icons'

interface VideoBadgeProps {
  hasVideo?: boolean
}

const BADGE_CLASSES = 'absolute bottom-2 right-2 z-10 w-10 h-10 xl:w-14 xl:h-14 flex items-center justify-center'

export function VideoBadge({ hasVideo }: VideoBadgeProps) {
  if (!hasVideo) return null

  return (
    <span className={BADGE_CLASSES} aria-label="Produs cu video">
      <YouTubeIcon />
    </span>
  )
}
